import React from 'react';
import { Box, BoxProps } from '@mui/material';

import { TP_COLORS } from '../../constants';
import { useAppSelector } from '../../hooks';
import { getThemeMode } from '../../store/ConfigSlice';

const CustomGrayContainer: React.FC<BoxProps> = ({
  style,
  children,
  ...props
}) => {
  // Store
  const themeMode = useAppSelector(getThemeMode);

  const defaultStyles: BoxProps['style'] = {
    padding: '15px',
    borderRadius: '7px',
    backgroundColor:
      themeMode === 'light'
        ? TP_COLORS.paperGray.light
        : TP_COLORS.paperGray.dark,
  };

  return (
    <Box
      {...props}
      style={style ? { ...defaultStyles, ...style } : defaultStyles}
    >
      {children}
    </Box>
  );
};

export default CustomGrayContainer;
